import api from "@/api.js";
import apiV2 from "@/apiV2.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: null,
    currentLoading: false,
    selectedOutcome: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setSelectedOutcome(state, payload) {
      state.selectedOutcome = payload;
    },
  },
  actions: {
    async loadAll({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("businessOutcomePlans", {
        params: { id: id },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, params) {
      commit("setCurrentLoading", true);
      let list = await api.get("businessOutcomePlans/byID", {
        params: params,
      });
      commit("setCurrent", list.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadByOutcomeID({ commit }, id) {
      commit("setCurrentLoading", true);
      let list = await api.get("businessOutcomePlans/byOutcomeID", {
        params: { id: id },
      });
      commit("setCurrent", list.data[0]);
      commit("setCurrentLoading", false);
    },
    async updateSelectedOutcome({ commit }, outcome) {
      commit("setSelectedOutcome", outcome);
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("businessOutcomePlans", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      dispatch("loadByOutcomeID", payload.outcome_id);
      return returnData;
    },

    async resetQuestionnaire({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("businessOutcomePlans/resetQuestionnaire", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });

      return returnData;
    },
    async markQuestionnaireFinished({ dispatch }, payload) {
      let returnData = {};
      await apiV2
        .post("OutcomeQuestionnaire/MarkQuestionnaireFinished", payload)
        .then((response) => {
          if (response.data.Result === "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });

      dispatch("loadByOutcomeID", payload.id);

      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    selectedOutcome(state) {
      return state.selectedOutcome;
    },
  },
};
